import { Directive, HostListener, Output, EventEmitter } from '@angular/core';

@Directive({
  selector: '[appFileDrop]'
})
export class FileDropDirective {

  @Output() filesDropped = new EventEmitter<File[]>();
  @Output() filesHovered = new EventEmitter<boolean>();

  @HostListener('dragover', ['$event']) onDragOver(evt: DragEvent) {
    evt.preventDefault();
    evt.stopPropagation();
    this.filesHovered.emit(true);
  }

  @HostListener('dragleave', ['$event']) onDragLeave(evt: DragEvent) {
    evt.preventDefault();
    evt.stopPropagation();
    this.filesHovered.emit(false);
  }

  @HostListener('drop', ['$event']) onDrop(evt: DragEvent) {
    evt.preventDefault();
    evt.stopPropagation();
    this.filesHovered.emit(false);

    const files = Array.from(evt.dataTransfer?.files || []);
    this.filesDropped.emit(files);
  }
}
